/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { hatsAppStrictHttpResponse } from '../../hats-app-strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiTwilioWhatsappIncomingPost$Params {
}

export function apiTwilioWhatsappIncomingPost(http: HttpClient, rootUrl: string, params?: ApiTwilioWhatsappIncomingPost$Params, context?: HttpContext): Observable<hatsAppStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiTwilioWhatsappIncomingPost.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as hatsAppStrictHttpResponse<void>;
    })
  );
}

apiTwilioWhatsappIncomingPost.PATH = '/api/twilio/whatsapp/incoming';
